$(document).ready(function () {
  $('.story-clinical-person-header').on('click', function () {
    $(this).toggleClass('active')
    $(this).next().slideToggle()
  })
})
